import PanelSection from "../intelligence/PanelSection";
import { formatCompletedTime } from "../intelligence/intelligenceLabels";
import SourceHealthBadge from "./SourceHealthBadge";

const RecentFailuresCard = ({ failures, runs }) => {
  const failureRuns = (runs || []).filter((run) =>
    ["failed", "completed_with_errors"].includes(run.runStatus)
  );
  const combined = [
    ...failureRuns.map((run) => ({
      id: run.runId,
      sourceCode: run.sourceCode,
      sourceName: run.sourceName,
      runStatus: run.runStatus,
      errorMessage: run.errorMessage,
      completedAt: run.completedAt || run.startedAt,
    })),
    ...(failures || []).map((failure, index) => ({
      id: `failure-${failure.sourceCode}-${index}`,
      sourceCode: failure.sourceCode,
      sourceName: failure.sourceCode,
      runStatus: failure.runStatus,
      errorMessage: failure.errorMessage,
      completedAt: failure.completedAt,
    })),
  ];

  const unique = [];
  const seen = new Set();

  for (const item of combined) {
    const key = `${item.sourceCode}-${item.errorMessage}-${item.completedAt}`;
    if (seen.has(key)) {
      continue;
    }

    seen.add(key);
    unique.push(item);
  }

  const items = unique.slice(0, 10);

  return (
    <PanelSection eyebrow="Issues" title="Recent failures" countLabel={`${items.length} shown`}>
      {!items.length ? (
        <p className="muted">No recent failed or partial runs.</p>
      ) : (
        <div className="admin-data-health-runs">
          {items.map((item) => (
            <article key={item.id} className="admin-data-health-run-row">
              <div className="admin-data-health-run-row__head">
                <strong>{item.sourceName || item.sourceCode}</strong>
                <SourceHealthBadge status={item.runStatus} />
              </div>
              <p className="admin-data-health-meta">{formatCompletedTime(item.completedAt)}</p>
              <p className="admin-data-health-error">{item.errorMessage || "No error message"}</p>
            </article>
          ))}
        </div>
      )}
    </PanelSection>
  );
};

export default RecentFailuresCard;
